import { render } from "./ExecuteProposal.vue?vue&type=template&id=1f4fe344"
import script from "./ExecuteProposal.vue?vue&type=script&lang=js"
export * from "./ExecuteProposal.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__